import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { Box } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { setLocale, getLocale } from 'translations/translator';
import WorksheetSideMenu from './worksheet-side-menu';
import TemplateSelector from '../containers/template-selector';
import HomePageContainer from '../containers/homepage-container';

const WorksheetMenu = () => {
  const params = useParams();
  const sectionId = +params?.sectionId!;

  const classes = useStyles();
  const { container, menu, content } = classes;
  const [language, setLanguage] = useState('EN_US');

  const handleToggle = () => {
    const otherLanguage = language === 'ES_US' ? 'EN_US' : 'ES_US';
    setLanguage(otherLanguage);
    setLocale(otherLanguage);
  };

  useEffect(() => {
    const locale = getLocale();
    setLanguage(locale);
  }, [language]);

  return (
    <Box className={container}>
      <Box className={menu}>
        <WorksheetSideMenu menuSectionId={sectionId} />
      </Box>
      <Box className={content}>
        {sectionId === 0 ? (
          <HomePageContainer language={language} handleToggle={handleToggle} />
        ) : (
          <TemplateSelector
            language={language}
            handleToggle={handleToggle}
            menuSectionId={sectionId}
          />
        )}
      </Box>
    </Box>
  );
};

export default WorksheetMenu;

const useStyles = makeStyles({
  container: {
    margin: 'auto',
    width: '90%',
    height: '80%',
    border: '1px solid #cccccc',
    borderRadius: 5,
    display: 'flex',
    marginTop: '4%'
  },
  menu: {
    width: '20%',
    height: '100%',
    borderRight: '1px solid #cccccc',
    overflowY: 'auto',
    '@media (max-width: 1000px)': {
      width: '30%'
    },
    '@media (max-width: 800px)': {
      width: '40%'
    },
    '@media (max-width: 600px)': {
      width: '50%'
    }
  },
  content: {
    width: '80%',
    display: 'flex',
    justifyContent: 'center',
    alignContent: 'center',
    '@media (max-width: 1000px)': {
      width: '70%'
    },
    '@media (max-width: 800px)': {
      width: '60%'
    },
    '@media (max-width: 600px)': {
      width: '50%'
    }
  }
});
